<template>
  <footer class="p-1">
    <div
      class="container-fluid fixed-bottom bg-secondary text-white p-2 d-flex justify-content-between align-items-center"
    >
      <span class="p-1 m-1">Built by eHealth4everyone</span>
      <el-badge
        :value="recentActivityCount"
        :hidden="recentActivityCount === 0"
        class="activity-badge"
      >
        <el-button type="text" class="mod-btn" @click="showActivityLog">
          <i class="el-icon-document"></i>
          Show Activity Log
        </el-button>
      </el-badge>
    </div>

    <!-- Activity Log Dialog -->
    <ActivityLog ref="activityLogDialog" />
  </footer>
</template>

<script>
import { mapGetters } from "vuex";
import ActivityLog from "@/views/ActivityLog.vue";

export default {
  name: "Footer",
  components: {
    ActivityLog,
  },
  computed: {
    ...mapGetters("activity", ["recentActivities"]),
    recentActivityCount() {
      return this.recentActivities ? this.recentActivities.length : 0;
    },
  },
  methods: {
    showActivityLog() {
      this.$refs.activityLogDialog.show();
    },
  },
};
</script>

<style lang="scss" scoped>
.mod-btn {
  font-size: 0.875rem;
  color: #ffffff !important;
  cursor: pointer;
  background: none;
  border: 1px solid rgba(255, 255, 255, 0.5);
  border-radius: 4px;
  padding: 5px 15px;
  text-decoration: none;
  transition: all 0.3s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
    border-color: #fff;
  }

  i {
    margin-right: 5px;
  }
}

.activity-badge {
  ::v-deep .el-badge__content {
    background-color: #409eff;
  }
}
</style>
